<template>
    <div>
        <h5 class="text-center">Scan Location</h5>
        <GmapMap
        :center="center"
        :zoom="zoom"
        map-type-id="terrain"
        style="width: 100%; min-height: 400px"
        >
            <template v-if="!notScanned">
                <gmap-marker
                v-for="(p,index) in position"
                :position="p.pos"
                :draggable="true"
                :key="index"
                :icon="p.markerOptions"
                :label="p.label"
                @click="center  = p.pos; zoom = 15"
                ></gmap-marker>
            </template>
            
            
        </GmapMap>
        <div v-if="notScanned">
            <h4 class="text-center" style="color:red">The location of the product is not currently known.</h4>
        </div>
        
    </div>
    
</template>

<script>
export default {
    props : ['location'],
    data(){

        var center = {
            lat : this.location[0].lat ? parseFloat(this.location[0].lat) : -7.860970,
            lng : this.location[0].lng ? parseFloat(this.location[0].lng) : 114.019304
        }

        var zoom = 10;

        var notScanned = false;
        var position  = []

        if(this.location.length > 0){
            for(var i  = 0; i < this.location.length ; i++) {
                position.push({
                    pos: {
                        lat : parseFloat(this.location[i].lat),
                        lng : parseFloat(this.location[i].lng),
                    },
                    label: String.fromCharCode(65 + i),

                })
            }
        }
        else{
            notScanned = true;
        }
            
        return {
            center , 
            position,
            zoom,
            notScanned : notScanned
        }
    }
    
}
</script>